export const downloadFile = (base64bytes, fileName) => {
    let a = document.createElement('A');
    a.href = `data:application/pdf;base64,${base64bytes}`;
    a.target = '_blank';
    a.download = `${fileName}.pdf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}

export const downloadExcelFile = (base64bytes, fileName) => {
    let a = document.createElement('A');
    a.href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${base64bytes}`;
    a.target = '_blank';
    a.download = `${fileName}.xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}

export const downloadBytesInfoFile = (base64bytes, fileName) => {
    let bytesParts = base64bytes.split("\n");
    let a = document.createElement('A');
    a.href = `${bytesParts.length > 1 ? bytesParts[1] : base64bytes}`;
    a.target = '_blank';
    a.download = `${fileName}.${ bytesParts.length > 1 ? bytesParts[0] : base64bytes.split(";")[0].split(":")[1].split("/")[1] }`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}